import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const SettingsLayout = lazy(() =>
  import('@/features/settings/SettingsLayout').then((m) => ({ default: m.SettingsLayout })),
);

export const Route = createFileRoute('/app/settings')({
  component: () => (
    <Suspense>
      <SettingsLayout />
    </Suspense>
  ),
});
